export default function debounce(fn, wait) {
  let lastFn = null;
  let interval;
  let timeout;

  function startInterval() {
    interval = setInterval(() => {
      if (lastFn) {
        lastFn();
        lastFn = null;
      }
    }, wait);
  }

  return function() {
    lastFn = fn.bind(this, ...arguments);
    if (!interval) {
      startInterval();
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      clearInterval(interval);
      interval = null;
    }, wait)
  }
}


// WEBPACK FOOTER //
// ./src/scripts/utils/debounce.js